<div class="container-fluid">
  <h3 id="upper"> Pta par periode ({{projetDataSource.length}}) </h3>

  <!-- <h4 id="upper">Pta par période ({{projetData.length}})</h4> -->
  <div class="d-flex justify-content-end">

    <!-- Ajout des champs de date -->
    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Début:
        <input disabled type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
      </label>
    </div>

    <div class="me-3">
      <label class="d-inline-flex align-items-center">
        Fin:
        <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
      </label>
    </div>

    <!-- <div *ngIf="showFiltre === true" class="me-3">
            <div id="tickets-table_filter" class="dataTables_filter">
                <label class="d-inline-flex align-items-center">
                    Direction:
                    <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
                        [(ngModel)]="selectedDirection" (change)="getStatistique()">
                        <option value="Sélectionner une direction">Sélectionner une direction</option>
                        <option *ngFor="let item of directionItems" [ngValue]="item"> {{ item?.libelle}}
                        </option>
                    </select>
                </label>
            </div>




        </div>
        <div class="me-3">
            <div id="tickets-table_filter" class="dataTables_filter">
                <label class="d-inline-flex align-items-center">
                    Service:
                    <select type="text" name="searchTerm" class="form-select ms-2" aria-controls="tickets-table"
                        [(ngModel)]="selectedService" (change)="getStatistique()">
                        <option disabled value="Sélectionner une direction"></option>
                        <option *ngFor="let item of serviceItems" [ngValue]="item"> {{ item?.libelle}}</option>
                    </select>
                </label>
            </div>
        </div> -->




    <div>
      <div class="me-3">
        <div id="tickets-table_filter" class="dataTables_filter">
          <input (click)="getStatistique()" type="button" value="Rechercher" class=" btn btn-primary">
        </div>
      </div>

    </div>
    <div class="dropdown d-inline-block " ngbDropdown>
      <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
        aria-haspopup="true" aria-expanded="false">
        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>

      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format
          PDF</a>
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('xlsx')">Au format
          Excel</a>
      </div>

    </div>
  </div>

  <!-- Tableau hiérarchique -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-centered table-hover datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
                <tr>
                  <th style="width: 120px;">Code</th>
                  <th style="min-width: 300px;">Programme / Actions / Activités / Tâches</th>
                  <th style="width: 120px;">Date Début</th>
                  <th style="width: 120px;">Date Fin</th>
                  <th style="width: 80px;">Poids (%)</th>
                  <th style="width: 150px;">Montant</th>
                  <th style="min-width: 200px;">Structure Responsable</th>
                </tr>
              </thead>
              <tbody>
                <!-- Message de chargement -->
                <!--   <tr *ngIf="isLoading">
                  <td colspan="7" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Chargement...</span>
                    </div>
                    <p class="mt-2">Chargement des données...</p>
                  </td>
                </tr> -->

                <!-- Message si pas de données -->
                <tr *ngIf="!isLoading && displayedItems.length === 0">
                  <td colspan="7" class="text-center py-5">
                    <i class="mdi mdi-information-outline mdi-48px text-muted"></i>
                    <p class="mt-2 text-muted">Aucune donnée disponible. Veuillez effectuer une recherche.</p>
                  </td>
                </tr>

                <!-- Lignes de données hiérarchiques -->
                <tr *ngFor="let item of displayedItems" [class]="getItemClass(item.type)" [ngStyle]="{
    'background-color':
      item.type === 'programme' ? '#97CCF1' :
      item.type === 'action' ? '#D8B47A' :
      item.type === 'activite' ? '#709E74' : '#B48F8F'
  }">

                  <!-- Code -->
                  <td>
                    <span class="font-weight-bold">{{ item.code }}</span>
                  </td>

                  <!-- Libellé hiérarchique -->
                  <td>
                    <div [style.padding-left.px]="(item.level || 0) * 25" class="d-flex align-items-center">

                      <!-- Chevron PrimeNG -->
                      <button *ngIf="hasChildren(item)" class="p-button-text p-button-sm mr-2 expand-button"
                        (click)="toggleExpand(item, $event)">

                        <i class="pi" [ngClass]="item.isExpanded ? 'pi-chevron-down' : 'pi-chevron-right'">
                        </i>
                      </button>

                      <!-- Espaceur pour alignement -->
                      <span *ngIf="!hasChildren(item)" class="mr-4" style="width: 24px; display: inline-block;">
                      </span>

                      <!-- Badge type -->
                      <span class="badge mr-2" [ngClass]="{
          'badge-primary': item.type === 'programme',
          'badge-info': item.type === 'action',
          'badge-success': item.type === 'activite',
          'badge-warning': item.type === 'tache'
        }" style="min-width: 80px; font-size: 0.75em;">

                        {{ getTypeLabel(item.type) }}
                      </span>

                      <!-- Libellé -->
                      <span class="text-truncate" [ngClass]="{
          'font-weight-bold text-dark h6 mb-0': item.type === 'programme',
          'font-weight-bold text-dark': item.type === 'action',
          'text-dark': item.type === 'activite',
          'text-muted': item.type === 'tache'
        }" [title]="item.libelle">

                        {{ item.libelle }}
                      </span>
                    </div>
                  </td>

                  <!-- Date début -->
                  <td>
                    <small>{{ formatDate(item.date_debut) }}</small>
                  </td>

                  <!-- Date fin -->
                  <td>
                    <small>{{ formatDate(item.date_fin) }}</small>
                  </td>

                  <!-- Poids -->
                  <td class="text-center">
                    <span class="badge badge-light">{{ item.poids }}%</span>
                  </td>

                  <!-- Montant -->
                  <td class="text-right">
                    <span class="font-weight-medium" [class.text-primary]="item.type === 'programme'"
                      [class.text-info]="item.type === 'action'">

                      {{ formatMontant(item.montant) }}
                    </span>
                  </td>

                  <!-- Responsable -->
                  <td>
                    <small class="text-muted">{{ item.responsable || '-' }}</small>
                  </td>

                </tr>


              </tbody>
            </table>

          </div>
          <!-- <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
            [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator> -->
          <!-- Statistiques globales -->
          <div class="row mt-3" *ngIf="displayedItems.length > 0">
            <div class="col-12">
              <div class="alert alert-info">
                <div class="row">
                  <div class="col-md-3">
                    <strong>Total Programmes:</strong>
                    {{ projetData.length }}
                  </div>
                  <div class="col-md-3">
                    <strong>Total Actions:</strong>
                    {{ countByType('action') }}
                  </div>
                  <div class="col-md-3">
                    <strong>Total Activités:</strong>
                    {{ countByType('activite') }}
                  </div>
                  <div class="col-md-3">
                    <strong>Total Tâches:</strong>
                    {{ countByType('tache') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
